export const APP_NAME = 'Ripik Core';

export const RIPIK_INTERNAL_DOMAIN = '@ripik.ai';

export const ROUTES = {
  LOGIN: '/login',
  OTP: '/login/otp',
  FORBIDDEN: '/forbidden',
  DEPLOYMENTS: '/deployments',
  DEPLOYMENT_DETAIL: '/deployments/:id',
  DEPLOYMENT_LIVE: '/deployments/:id/live',
  DEPLOYMENT_LIVE_TERMINAL: '/deployments/:id/terminal',
  DEPLOYMENT_LIVE_CONSENSUS: '/deployments/:id/consensus',
  DEPLOYMENT_LIVE_BROADCAST: '/deployments/:id/broadcast',
  DEPLOYMENT_LIVE_HUD: '/deployments/:id/command',
  DEPLOYMENT_LIVE_BOARD: '/deployments/:id/board',
  DEPLOYMENT_OVERVIEW: '/deployments/:id/overview',
  DEPLOYMENT_DASHBOARD: '/deployments/:id/dashboard',
  DEPLOYMENT_RECOMMENDATIONS: '/deployments/:id/recommendations',
  DEPLOYMENT_ALERTS: '/deployments/:id/alerts',
  DEPLOYMENT_SETTINGS: '/deployments/:id/settings',
  DEPLOYMENT_SIMULATION: '/deployments/:id/simulation',
  USERS: '/users',
  SETTINGS: '/settings',
  PROFILE_EDIT: '/profile/edit',
};

export const STATUS_LABELS = {
  active: 'Active',
  provisioning: 'Provisioning',
  inactive: 'Inactive',
  archived: 'Archived',
};


/** Storage key for Zustand persist. Bump suffix on breaking schema changes. */
export const AUTH_STORAGE_KEY = 'ripik-auth.v1';
